import { AppController, createDefaultDependencies, getElements } from "./appController";
import { getRecentLogs, installGlobalDiagnostics, log } from "./services/logger";

Office.onReady((info: { host: Office.HostType; platform: Office.PlatformType }) => {
  installGlobalDiagnostics();
  log("info", "office.ready", { host: info.host, platform: info.platform });

  if (info.host !== Office.HostType.Word) {
    log("warn", "office.unsupportedHost", { host: info.host });
    return;
  }

  const app = new AppController(getElements(), createDefaultDependencies());
  app.initialize();
  (window as unknown as { MarkdownWordDiagnostics?: { getRecentLogs: typeof getRecentLogs } }).MarkdownWordDiagnostics = {
    getRecentLogs,
  };
});